import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '@this/components/shared/footer/footer';
import Header from '@this/components/user_signin/user_signin_header';
import { Alert } from '@this/shared/ui/feedbacks/alert';
import { Button } from '@this/shared/ui/inputs/button';

interface Props {
  serviceId: number;
}

const AdminGoogleSignIn: React.FC<Props> = ({ serviceId }) => {
  const params = new URLSearchParams(window.location.search);
  const errorType = params.get('error_type');
  const notice = params.get('notice');

  return (
    <div style={{ background: "url('/images/user_signin/bg.png') center / cover no-repeat", color: '#fff' }}>
      <Helmet>
        <title>管理者ログイン</title>
      </Helmet>
      <Header />
      <div style={{ maxWidth: 350, margin: '0 auto', padding: '24px 16px 40px' }}>
        <h2 style={{ fontSize: 16, fontWeight: 500, marginBottom: 16 }}>管理者ログイン</h2>
        {notice === 'email_changed' ? (
          <Alert variant="success" style={{ marginBottom: 16 }}>
            管理者の情報を更新しました。新しいメールアドレスのGoogleアカウントでログインしてください。
          </Alert>
        ) : null}
        {errorType === 'not_registered' ? (
          <p style={{ marginBottom: 16 }}>
            ログインに失敗しました。
            <br />
            登録されていないユーザです。
          </p>
        ) : null}
        <p style={{ marginBottom: 16 }}>
          管理者マスタに登録されたメールアドレスのGoogleアカウントでログインしてください
        </p>
        <Button href="/admins/auth/google" isExternal fullWidth>
          Googleでログイン
        </Button>
      </div>
      <Footer signedIn={false} serviceId={serviceId} />
    </div>
  );
};

export default AdminGoogleSignIn;
